import * as React from 'react';
import { Dispatch } from 'react-redux';
import { I18n } from 'react-redux-i18n';
import * as copy from 'copy-to-clipboard';

import { StoreState } from '../../../reducers';
import HeaderDropdown, { HeaderDropdownOption } from '../Header/Dropdown';
import { PopupTheme } from '../../Popup';
import { NewStyleColor } from '../../../utils/styles-constants';
import { initiateShare, sharePublicationViaCopy } from '../../../containers/Share/actions';
import { createNotification } from '../../../containers/NotificationBar/actions';
import { getPreprodPublicationUrl, openPreview, openAccessibleVersionPreview } from '../../../containers/Editor/actions';
import DriveItemUtils from '../../../utils/driveItem';
import { Api } from '../../../typings/api';

interface ButtonPreviewProps {
	url: string;
	clientId: number;
	tempGId: number;
	label: string;
	isDisabled: boolean;
	driveItem: Api.DriveItem;
	isShareByCopyEnabled: boolean;
	isShareByEmailEnabled: boolean;
	dispatch: Dispatch<StoreState>;
	isAccessibleVersion: boolean;
}

const ButtonPreview = ({
	url,
	driveItem,
	clientId,
	tempGId,
	label,
	isShareByCopyEnabled,
	isShareByEmailEnabled,
	isDisabled,
	dispatch,
	isAccessibleVersion,
}: ButtonPreviewProps) => {
	const isProposal = DriveItemUtils.isProposal(driveItem.format);

	const handleOpenPreviewClick = () => {
		if (isAccessibleVersion) {
			dispatch(openAccessibleVersionPreview());
			return;
		} else {
			dispatch(openPreview(driveItem.id));
		}
	};

	const handleGetUrlClick = () => {
		if (isProposal) {
			dispatch(sharePublicationViaCopy(clientId, tempGId, label, driveItem.format, PopupTheme.DARK));
			return;
		}

		if (url) {
			copy(url);
			dispatch(createNotification('info.url_copied'));
		} else {
			dispatch(createNotification('error.get_publication_url'));
			dispatch(getPreprodPublicationUrl(clientId, tempGId, label, true));
		}
	};

	const handleSendByEmailClick = () => {
		dispatch(initiateShare([driveItem], true, Api.ShareNetwork.Uprez));
	};

	const options: HeaderDropdownOption[] = [];

	if (!isProposal) {
		options.push({
			label: 'messages.see_preview',
			icon: {
				name: 'iconset_uprez_eye',
				width: '23px',
				height: '16px',
			},
			onClick: handleOpenPreviewClick,
		});

		if (isShareByCopyEnabled) {
			options.push({
				label: 'messages.get_url',
				icon: {
					name: 'iconset_uprez_link2',
					width: '23px',
					height: '23px',
				},
				onClick: handleGetUrlClick,
			});
		}

		if (isShareByEmailEnabled) {
			options.push({
				label: 'messages.send_by_email',
				icon: {
					name: 'iconset_uprez_send2',
					width: '23px',
					height: '23px',
				},
				onClick: handleSendByEmailClick,
			});
		}
	}

	return (
		<HeaderDropdown
			buttonLabel="messages.preview"
			dropdownTitle={I18n.t('messages.preview')}
			color={NewStyleColor.Blue450}
			isDisabled={isDisabled}
			options={options}
			onButtonClick={isProposal ? handleOpenPreviewClick : undefined}
		/>
	);
};

export default ButtonPreview;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/ButtonPreview/index.tsx